import React from 'react';
import { CheckIcon } from 'lucide-react';
import { tradingBenefits, tickers } from '../data/content';
import { CandleChart } from './charts/CandleChart';
import { Sparkline } from './charts/Sparkline';
import { ReferralButton } from './ReferralButton';
import { Reveal } from './Reveal';
export function TradingSection() {
  return <section id="trading" className="relative overflow-hidden border-y border-hairline bg-surface px-5 py-24 lg:px-8 lg:py-32" data-id="element-271" data-mp="tm9tj1n10n5c">
      <div className="pointer-events-none absolute left-0 top-1/3 h-[420px] w-[520px] -translate-x-1/3 opacity-60" style={{
      background: 'radial-gradient(50% 50% at 50% 50%, rgba(247,162,59,0.14), rgba(5,5,5,0) 70%)'
    }} aria-hidden="true" data-id="element-272" data-mp="kurhn2x44ti2" />

      <div className="mx-auto grid max-w-shell items-center gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-273" data-mp="5wz2ibvha74e">
        <Reveal data-id="element-274" data-mp="1v3tel7b2pg2">
          <div className="glass overflow-hidden rounded-3xl p-5 shadow-[0_50px_130px_-50px_rgba(0,0,0,0.95)] lg:p-6" data-id="element-275" data-mp="1wonyatme8dx">
            <div className="flex flex-wrap items-center justify-between gap-3 border-b border-hairline pb-4" data-id="element-276" data-mp="3j28kwwdeq9jr">
              <div className="flex items-baseline gap-3" data-id="element-277" data-mp="3nvun1uly2v1b">
                <span className="text-lg font-bold text-white" data-id="element-278" data-mp="396ezenhpn5pu">SOL/USDT</span>
                <span className="text-[13px] font-semibold text-gain" data-id="element-279" data-mp="3e4gpvthgu7bc">+3.14%</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-280" data-mp="5p6kocia4lzc">
                {['1m', '15m', '1H', '1D', 'S'].map((tf, i) => <span key={tf} className={`rounded-md px-2 py-1 text-[11px] font-medium ${i === 2 ? 'bg-brand-dim text-brand' : 'text-ink-muted'}`} data-id="element-281" data-mp="amympzcn1oh9" data-mpi={i}>
                    {tf}
                  </span>)}
              </div>
            </div>

            <div className="mt-4 grid gap-5 lg:grid-cols-[1fr_150px]" data-id="element-282" data-mp="2lg2ullhrhp3h">
              <CandleChart height={252} seed={7} count={32} data-id="element-283" data-mp="2lhdxlj3dustj" />
              <div className="space-y-3" data-id="element-284" data-mp="rwal7hp5agzd">
                <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-ink-muted" data-id="element-285" data-mp="rzevmwt7e8yh">
                  Watchlist
                </p>
                {tickers.map(t => <div key={t.pair} className="flex items-center justify-between gap-2 rounded-xl border border-hairline px-3 py-2.5" data-id="element-286" data-mp="i5pra7kf20ms">
                    <div data-id="element-287" data-mp="985mwpr9bo7y">
                      <p className="text-[12px] font-medium text-white" data-id="element-288" data-mp="94huxv1gn9vc">{t.pair}</p>
                      <p className={`text-[11px] font-semibold tabular-nums ${t.change >= 0 ? 'text-gain' : 'text-loss'}`} data-id="element-289" data-mp="49ucodx1vbp7">
                        {t.change >= 0 ? '+' : ''}
                        {t.change.toFixed(2)}%
                      </p>
                    </div>
                    <Sparkline points={t.trend} positive={t.change >= 0} className="!w-10" data-id="element-290" data-mp="1oowb23hzn9dd" />
                  </div>)}
              </div>
            </div>
            <p className="mt-4 text-[11px] text-white/35" data-id="element-291" data-mp="215ovyovt56qo">
              Interfaz ilustrativa con datos ficticios. No representa precios reales.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-292" data-mp="2awjlc24comgc">
          <h2 className="text-[30px] font-extrabold uppercase leading-[1] tracking-tightest text-white sm:text-[40px]" data-id="element-293" data-mp="2aup00mp62sbq">
            Tu mercado. Tu estrategia.
            <span className="block text-brand" data-id="element-294" data-mp="1i72wfefxvnov">Tus decisiones.</span>
          </h2>
          <p className="mt-5 max-w-[520px] text-[15px] leading-relaxed text-ink-muted" data-id="element-295" data-mp="1i95v0mv5qp57">
            Accede a una experiencia de trading moderna con información de mercado y herramientas
            diseñadas para explorar diferentes oportunidades dentro del ecosistema crypto.
          </p>

          <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-296" data-mp="2ynysc872nrxx">
            {tradingBenefits.map(benefit => <li key={benefit} className="flex items-center gap-2.5" data-id="element-297" data-mp="gc8a39wrzwjf">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-dim" data-id="element-298" data-mp="gci2t597ghst">
                  <CheckIcon className="h-3 w-3 text-brand" aria-hidden="true" data-id="element-299" data-mp="bf85z4jhl3uy" />
                </span>
                <span className="text-[14px] text-white" data-id="element-300" data-mp="pajx71yfoc74">{benefit}</span>
              </li>)}
          </ul>

          <ReferralButton location="trading_section" size="lg" showArrow className="mt-9" data-id="element-301" data-mp="zauccs413tox">
            Empezar ahora
          </ReferralButton>
        </Reveal>
      </div>
    </section>;
}